/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import {FunctionComponent} from 'react';
import {useSelector} from "react-redux";
import {ShowHide} from "../../atoms/layout/ShowHide";
import {ProductCardIcon} from "../../atoms/ProductCardIcon";
import {ConditionalWrapper} from "../../atoms/helper/ConditionalWrapper";
import {getAEMResource, getHomepage, getResource} from "../../../selectors/generic";
import {registerAEMComponent} from "../../../utils/aem";

interface IProps {
    tags: any,
    model?: string,
    combineHealthWellbeing?: boolean,
    amountOfHealthWellbeing?: number
}

export const PlantForwardIcons: FunctionComponent<IProps> = ({tags, model, combineHealthWellbeing = false, amountOfHealthWellbeing = 0}) => {

    const plantForwardConfig = useSelector(state => getHomepage(state)?.plantForwardConfiguration);
    const productPageTags =  useSelector(state => getAEMResource(state, model)?.tags);

    let isProductPage = false;
    let enablePlantForwardProductPages = false;

    if (!tags) {
        tags = productPageTags;
        isProductPage = true;
        enablePlantForwardProductPages = plantForwardConfig?.enablePlantForwardProductPages || false;
    }

    if (!plantForwardConfig || !plantForwardConfig.imageTagPair?.imagePath || !plantForwardConfig.imageTagPair?.tagPath
        || (isProductPage && !enablePlantForwardProductPages) || (!isProductPage && !plantForwardConfig.enablePlantForwardProductFinder)) {
        return null;
    }

    const show = tags?.findIndex(tag => tag.path === plantForwardConfig.imageTagPair.tagPath || tag === plantForwardConfig.imageTagPair.tagPath) > -1;
    const icon = plantForwardConfig.imageTagPair.imagePath;
    const label = plantForwardConfig.imageTagPair.tagTitle;
    const link = getResource(plantForwardConfig.link);
    const dotCom = useSelector(state => getHomepage(state).dotCom);

    return <ShowHide show={show}>
        {dotCom && combineHealthWellbeing && amountOfHealthWellbeing > 0 ?
            <ProductCardIcon icon={icon} label={label} plantForwardIcon={true}/>
            :
            <div className={`card-icon absolute-box bottom-right ${isProductPage ? "large" : ""} ${dotCom ? "dotCom" : ""}`}>
                <ConditionalWrapper condition={link && isProductPage}
                                    wrapper={children => <a href={link}>{children}</a>}>
                    <ProductCardIcon icon={icon} label={label} plantForwardIcon={true}/>
                </ConditionalWrapper>
            </div>}
    </ShowHide>
}

registerAEMComponent("react--plant-forward-icons", PlantForwardIcons);
